import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ContentChild,
  ContentChildren,
  input,
  output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  MatColumnDef,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRowDef,
  MatTable,
  MatTableModule,
} from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-table',
  imports: [MatTableModule, MatPaginatorModule, NgTemplateOutlet],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent<T> implements AfterContentInit {
  @ContentChildren(MatHeaderRowDef) headerRowDefs!: QueryList<MatHeaderRowDef>;
  @ContentChildren(MatRowDef) rowDefs!: QueryList<MatRowDef<T>>;
  @ContentChildren(MatColumnDef) columnDefs!: QueryList<MatColumnDef>;
  @ContentChild(MatNoDataRow) noDataRow!: MatNoDataRow;
  @ContentChild('expandedRow')
  expandedRowTemplate?: TemplateRef<unknown>;

  @ViewChild(MatTable, { static: true }) table!: MatTable<T>;

  columns = input.required<
    {
      columnDef: string;
      header: string;
      cell: (element: T) => string;
      useTemplate?: boolean;
    }[]
  >();

  dataSource = input.required<T[]>();

  totalCount = input.required<number>();

  displayedColumns = computed(() => this.columns().map((c) => c.columnDef));

  expandableRows = input(false);

  showPaginator = input(true);

  pageChange = output<PageEvent>();

  expandedElement: T | null = null;

  ngAfterContentInit() {
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
    // this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef));
    // this.headerRowDefs.forEach((headerRowDef) => this.table.addHeaderRowDef(headerRowDef));
    // this.table.setNoDataRow(this.noDataRow);
  }

  handlePageEvent(e: PageEvent): void {
    this.pageChange.emit(e);
  }

  isExpanded(element: T) {
    return this.expandedElement === element;
  }

  toggle(element: T) {
    this.expandedElement = this.isExpanded(element) ? null : element;
  }

  isExpandableRows = () => this.expandableRows();
}
